import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElectricalSidebar from './ElectricalSidebar';

function RingMainUNit() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="rmu-panel">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 mb-4">
            {/* Title */}
            <div className="text-center mb-4" data-aos="fade-up">
              <h2 className="fw-bold">🔁 RING MAIN UNIT (RMU)</h2>
              <p className="text-muted">
                RMUs are compact, sealed units used in medium-voltage power distribution networks for switching, protection, and fault isolation. They are widely used in urban power distribution, industrial zones, commercial buildings, and renewable energy systems, especially where space is limited and reliability is critical.
              </p>
            </div>

            {/* Ratings */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">📏 Ratings</h4>
              <ul className="text-muted">
                <li><strong>Voltage Class:</strong> 11kV / 33kV</li>
                <li><strong>Current Rating:</strong> Up to 800A</li>
                <li><strong>Short Circuit Rating:</strong> Up to 25kA for 3 sec</li>
                <li><strong>Insulation Type:</strong> SF₆ or solid insulated</li>
              </ul>
            </div>

            {/* IEC Standards */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">📘 IEC Standards</h4>
              <ul className="text-muted">
                <li>IEC 62271-200 – Metal-enclosed switchgear</li>
                <li>IEC 60265-1 – Load break switches</li>
              </ul>
            </div>

            {/* Key Features */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">✨ Key Features</h4>
              <ul className="text-muted">
                <li>Fully sealed and gas-insulated (SF₆) for maintenance-free operation</li>
                <li>Compact modular design suitable for confined spaces</li>
                <li>Integrated VCB or LBS with protection relays</li>
                <li>Arc fault containment and operator safety interlocks</li>
                <li>Remote operation ready (SCADA compatible)</li>
                <li>Ideal for loop and radial networks</li>
                <li>Long service life and corrosion-resistant enclosure</li>
              </ul>
            </div>

            {/* Call to Action */}
            <div
              className="p-4 bg-white border-start border-4 border-primary rounded shadow-sm"
              data-aos="fade-up"
            >
              <h5 className="text-dark fw-semibold">Need RMU Panels for Your Network?</h5>
              <p className="mb-2 text-muted">
                Contact us for customized RMU solutions tailored to your medium voltage distribution needs.
              </p>
              <a
                href="/contact"
                className="btn"
                style={{
                  backgroundColor: '#08717A',
                  color: '#fff',
                  border: 'none',
                }}
              >
                Contact Us
              </a>
            </div>
          </div>

          {/* Sidebar */}
          <ElectricalSidebar />
        </div>
      </div>
    </section>
  );
}

export default RingMainUNit;
